import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing/app-routing.module';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CollapseModule } from 'ngx-bootstrap/collapse';

import { AppComponent } from './app.component';
import { NavbarComponent } from "./navbar/navbar.component";
import { LoginComponent } from './login/login.component';
import { ContractListComponent } from './contract-list/contract-list.component';

import { DragulaModule } from 'ng2-dragula/ng2-dragula';

import { ContractService } from './service/contract.service'
import { PdfExportService } from './service/pdf-export.service'
import { WordExportService } from './service/word-export.service'
import { WordToPdfExportService } from './service/word-to-pdf-export.service'

import { ContractComponent } from './contract/contract.component'
import { ContractArticleComponent } from './contract-article/contract-article.component';
import { ContractInputComponent } from './contract-input/contract-input.component';
import { CategoryPipe } from './contract-list/category.pipe';
import { WizardComponent } from './wizard/wizard.component';
import { AppContainer } from './app-container/app.container';
import { TOA } from './toa/toa';
import { Privacy } from './privacy/privacy';
import { DataNote } from './data-note/data-note';
import { ScrollToTop } from './scroll-to-top/scroll-to-top';

import { FormsModule } from '@angular/forms';

import { NgxSpinnerModule } from 'ngx-spinner';




@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    LoginComponent,
    ContractListComponent,
    ContractComponent,
    ContractArticleComponent,
    ContractInputComponent,
    CategoryPipe,
    WizardComponent,
    AppContainer,
    TOA,
    DataNote,
    Privacy,
    ScrollToTop,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    CollapseModule.forRoot(),
    DragulaModule,
    FormsModule,
    NgxSpinnerModule
  ],
  providers: [ContractService, PdfExportService, WordExportService, WordToPdfExportService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/app.module.ts